export const notificationsKey = 'notificationsKey';
